import { useEffect, useState } from 'react';
import PetCard from './PetCard';
import { initializeUserTimezone } from './api';

function App() {
  const [petId, setPetId] = useState(null);

  useEffect(() => {
    const tg = window.Telegram?.WebApp;
    if (tg) {
      tg.ready();
      tg.expand();
    }

    initializeUserTimezone();

    const params = new URLSearchParams(window.location.search);
    const id = params.get('pet_id');
    if (id) setPetId(Number(id));
  }, []);

  if (!petId) {
    return (
      <div style={{ textAlign: 'center', padding: '40px', fontFamily: 'sans-serif' }}>
        <p>Открой через бота 🐾</p>
      </div>
    );
  }

  return <PetCard petId={petId} />;
}

export default App;
